<script>
import { VImg } from 'vuetify/lib';
export default VImg;
</script>
